/** @jsxImportSource @emotion/react */
import ProgressBar from '@ProgressBar';
import { useSelector } from 'react-redux';
import { calculateProgressValue } from './Progress.helpers';
import useIsForwardNavigationBlockedBySupplierCard from '../../Hooks/useIsForwardNavigationBlockedBySupplierCard/useIsForwardNavigationBlockedBySupplierCard';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const Progress = () => {
  const { currentPage, totalPages } = useSelector((store) => store.navigation);
  const { headerEnabled, headlineText, headlineLogo, submissionPageNumber } =
    useSelector((store) => store.formConfig);
  const { progressBar } = useSelector(
    (store) => store.formConfig?.fixedComponents
  );
  const { isNextPageCpcCard, showCpcRecommendations } = useSelector(
    (store) => store.cpcCard
  );

  const progressBarExperimentName = useGetExperimentName({
    componentName: 'ProgressBar',
  });

  const showingCpcCard = !!(isNextPageCpcCard || showCpcRecommendations);
  const { isForwardNavigationBlockedBySupplierCard } =
    useIsForwardNavigationBlockedBySupplierCard();

  // Some form journeys will result in an alternative endpoint, such as a CPC card or supplier card. In these cases, we want to show the progress bar as complete.
  const isAlternativeFormEnding =
    showingCpcCard || isForwardNavigationBlockedBySupplierCard;

  const progressValue =
    isAlternativeFormEnding === true
      ? 100
      : calculateProgressValue(currentPage, totalPages, submissionPageNumber);

  const headerIsPresent = headerEnabled && (headlineLogo || headlineText);

  if (totalPages === 1 && !headerIsPresent) {
    return <div style={{ height: 25, width: '100%' }} />;
  }

  if (totalPages === 1 && headerIsPresent) {
    return null;
  }

  if (
    typeof submissionPageNumber === 'number' &&
    currentPage > submissionPageNumber
  ) {
    // Don't show the progress bar if we have passed the submission page
    if (!headerIsPresent) {
      return <div style={{ height: 25, width: '100%' }} />;
    }

    return null;
  }

  return (
    <ProgressBar
      progress={progressValue}
      text={progressBar?.text ?? 'Progress:'}
      experimentName={progressBarExperimentName}
    />
  );
};

export default Progress;
